;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import get from "lodash/get"
import {
  COHORT_PRICE_TYPE_ALL_UPFRONT,
  COHORT_PRICE_TYPE_PER_SESSION,
} from "../constants"

type PaymentObj = {
  priceType?: string | null
  refundPolicyHours?: number | null
  refundPolicyPercent?: number | null
  priceValue?: number | null
}

type PaymentInput = {
  paymentObj: PaymentObj | null | undefined
}

export const cohortPriceType = ({ paymentObj }: PaymentInput): string | null => {
  return get(paymentObj, "priceType", null)
}

export const isPayPerSession = ({ paymentObj }: PaymentInput): boolean => {
  return cohortPriceType({ paymentObj }) === COHORT_PRICE_TYPE_PER_SESSION
}

export const isPayUpfront = ({ paymentObj }: PaymentInput): boolean => {
  return cohortPriceType({ paymentObj }) === COHORT_PRICE_TYPE_ALL_UPFRONT
}

export const getRefundPolicyHours = ({
  paymentObj,
}: PaymentInput): number | null => {
  return get(paymentObj, "refundPolicyHours", null)
}

export const getRefundPolicyPercent = ({
  paymentObj,
}: PaymentInput): number | null => {
  return get(paymentObj, "refundPolicyPercent", null)
}

export const getPrice = ({ paymentObj }: PaymentInput): number => {
  const cents = get(paymentObj, "priceValue", null)
  if (typeof cents !== "number") return 0
  return cents / 100
}

export const getPricePerSession = ({
  paymentObj,
  remainingSessions,
}: PaymentInput & { remainingSessions: number }): number | string => {
  if (isPayPerSession({ paymentObj })) {
    return getPrice({ paymentObj })
  }

  return remainingSessions > 0
    ? Math.round((getPrice({ paymentObj }) / remainingSessions) * 100) / 100
    : "N/A"
}
